import { render, staticRenderFns } from "./details.html?vue&type=template&id=713789c2&"
import script from "./details.js?vue&type=script&lang=js&"
export * from "./details.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports